import { Component, OnInit, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { OrderService } from '../../services/order.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import {Product} from '../../../dto/product';



export const PAYMENT_TYPE_SELECT_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => PaymentTypeSelectorComponent),
  multi: true,
};

@Component({
  selector: 'app-payment-type-selector',
  templateUrl: './payment-type-selector.component.html',
  styleUrls: ['./payment-type-selector.component.css'],
  providers: [PAYMENT_TYPE_SELECT_VALUE_ACCESSOR],
})

export class PaymentTypeSelectorComponent implements OnInit, ControlValueAccessor {

  @Input() productId: string;
  @Input() wantCardName: boolean;
  @Input() selectedProduct: Product;
  @Input() disabled: false;

  private _allowedPaymentMethods;

  get allowedPaymentMethods(): any {
    return this._allowedPaymentMethods;
  }

  @Input()
  set allowedPaymentMethods(val: any){
    this._allowedPaymentMethods = val;
    this.setPayment();

  }

  setPayment(){
    if( this.onChange ) {
      if ( this.allowedPaymentMethods.free ) {
        this.currentType = 'NO_PAYMENT';
        this.onChange({type: this.types.free});
      } else if(this.allowedPaymentMethods.voucher && !this.allowedPaymentMethods.invoice){
        this.currentType = 'VOUCHER';
        this.onChange({type: this.types.voucher});
      } else if(this.allowedPaymentMethods.sofort){
        this.currentType = 'SOFORT';
        this.onChange({type: this.types.sofort});
      } else if(this.allowedPaymentMethods.creditcard){
        this.currentType = 'CREDIT_CARD';
        this.onChange({type: this.types.creditcard});
      } else if(this.allowedPaymentMethods.cashOnDelivery){
        this.currentType = 'CASH';
        this.onChange({type: this.types.cashOnDelivery});
      } else {
        this.currentType = 'INVOICE';
        this.onChange({type: this.types.invoice});
      }
    }
  }

  types = {
    invoice: 'INVOICE',
    voucher: 'VOUCHER',
    sofort: 'SOFORT',
    cashOnDelivery: 'CASH',
    creditcard: 'CREDIT_CARD',
    free: 'NO_PAYMENT'
  };

  currentType = this.types.invoice;

  onChange;
  voucherCode;
  constructor(private orderService: OrderService,
    public snackBar: MatSnackBar,
  ) { }

  ngOnInit() {

  }

  writeValue(obj: any): void {
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
    this.setPayment();
    //this.onChange({ type: this.types.invoice });
  }
  registerOnTouched(fn: any): void {
  }
  setDisabledState?(isDisabled: boolean): void {
  }

  validateVoucher() {

    if(this.disabled) {
return;
}



    this.orderService.validateVoucherWithAmount(this.voucherCode, this.productId, this.wantCardName, this.currentType).subscribe(data => {
      this.onChange({ type: this.types.voucher, code: this.voucherCode, amountRemaining: data.amountRemaining });
    }, error => {
      this.onChange({ type: this.types.voucher });
      this.voucherCode = '';
      this.snackBar.open(error.error, null, {
        duration: 5000,
        panelClass: ['app-mat-snack-bar']
      });
    });
  }
  typeSelected(e) {
    this.currentType = e.value;
    if (e.value === this.types.invoice || e.value === this.types.sofort || e.value === this.types.creditcard || e.value === this.types.cashOnDelivery || e.value === this.types.free) {
      this.onChange({ type: e.value });
    } else {
      this.onChange(null);
    }

  }
}
